"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DynamicBreadcrumbsProvider = require("./DynamicBreadcrumbsProvider");

/**
 * Generate unique index value for breadcrumb.
 *
 * @returns {number}
 */
var genUniqueKey = function genUniqueKey() {
  return Math.floor(Math.random() * 10000000);
};

/**
 * Breadcrumb register item.
 *
 * @function
 * @param {object} props
 * @param {LinkProps.to} [props.to=undefined] - Url to be opened on click by breadcrumb.
 * @param {boolean} [props.hidden=false] - If you pass true this breadcrumb will be hidden from the breadcrumbs
 * list. It may useful if you want to render the last breadcrumb item as page title using FinalBreadcrumb but you
 * didn't want to show it in the breadcrumbs list.
 * @param {React.ReactNode} props.children - Title of breadcrumb.
 * @returns {React.Fragment}
 * @example
 * <BreadcrumbItem to="/teams/1">WEX</BreadcrumbItem>
 */
var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var _ref$to = _ref.to,
      to = _ref$to === void 0 ? undefined : _ref$to,
      children = _ref.children,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden;
  var key = (0, _react.useMemo)(genUniqueKey, []);

  var _useBreadcrumbsContex = (0, _DynamicBreadcrumbsProvider.useBreadcrumbsContext)(),
      addBreadcrumb = _useBreadcrumbsContex.addBreadcrumb,
      removeBreadcrumb = _useBreadcrumbsContex.removeBreadcrumb;

  (0, _react.useEffect)(function () {
    addBreadcrumb({
      key: key,
      to: to,
      children: children,
      hidden: hidden
    });
    return function () {
      removeBreadcrumb(key);
    };
  }, [addBreadcrumb, children, hidden, key, removeBreadcrumb, to]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
};

var _default = BreadcrumbItem;
exports["default"] = _default;